import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import ScrollMemory from 'react-router-scroll-memory';
import ReactCSSTransitionReplace from 'react-css-transition-replace';

import './index.css';
import './redesign/css/index.css';

import App from './App';
import {
	About,
	Clients,
	Home,
	NotFound,
	bau,
	coinjar,
	goget,
	lb,
	newscorp,
	tnt,
	toll,
	tlo,
	fedex,
	Terms,
	PrivacyPolicy,
	blog2020endofyearwrapup,
	blog20210302,
	blog20210310,
	blog20210512,
	blog20210604,
	blog20210727,
	SmsOptOut
} from './scenes';

import {
	Signup,
	Activate,
	// SetupAccount,
	// ForgotPassword,
	// PasswordReset,
	// Login,
	// Account,

	SignupWelcome,
	SignupMain,
	SignupComplete,

	Faqs,

	SignupUS,
	Contract,
} from './redesign';

render(
	<Router>
		<Switch>
			<Route path="/contract" component={Contract} />
			<Route path="/us/signup" component={SignupUS} />
			<Route path="/signup" component={Signup} />
			<Route path="/activate" component={Activate} />
			// https://app.asana.com/0/688855237267946/1137041046809539
			{/* <Route path="/setup-account" component={SetupAccount} /> */}
			{/* <Route path="/forgot-password" component={ForgotPassword} />
			<Route path="/reset-password" component={PasswordReset} /> */}
			{/* <Route path="/agent-login" component={Login} /> */}
			{/* <Route path="/account" component={Account} /> */}

			<Route path="/signup-welcome" component={SignupWelcome} />
			<Route path="/signup-overview" component={SignupMain} />
			<Route path="/signup-complete" component={SignupComplete} />

			<Route path="/agent/faqs" component={Faqs} />
			<Route path="/sms-opt-out/:key" component={SmsOptOut} />
			<Route path="/" render={({ location }) => (
				<App>
					<ScrollMemory />
						<ReactCSSTransitionReplace
							transitionName="fade"
							transitionEnterTimeout={600}
							transitionLeaveTimeout={300}
						>
						<div key={location.pathname}>
							<Switch location={location}>
								<Route exact path="/" component={Home} />
								<Route path="/about" component={About} />
								<Route path="/blog-2020endofyearwrapup" component={blog2020endofyearwrapup} />
								<Route path="/blogs/cryptocurrency" component={blog20210302} />
								<Route path="/blogs/footysback" component={blog20210310} />
								<Route path="/blogs/magicmay" component={blog20210512} />
								<Route path="/blogs/stateoforigin2021" component={blog20210604} />
								<Route path="/blogs/csr" component={blog20210727} />
								
								<Route path="/terms" component={Terms} />
								<Route path="/privacy-policy" component={PrivacyPolicy} />
								<Route path="/clients">
									<Switch>
										<Route exact path="/clients" component={Clients} />
										{/* <Route path="/clients/bitcoin-australia" component={bau} /> */}
										{/* <Route path="/clients/coinjar" component={coinjar} /> */}
										<Route path="/clients/goget" component={goget} />
										{/* <Route path="/clients/ladbrokes" component={lb} /> */}
										{/* <Route path="/clients/newscorp" component={newscorp} /> */}
										<Route path="/clients/tnt" component={tnt} />
										<Route path="/clients/teamglobalexpress" component={toll} />
										<Route path="/clients/thelotteryoffice" component={tlo} />
										<Route path="/clients/fedex" component={fedex} />
										<Redirect to="/notfound" />
									</Switch>
								</Route>

								<Route path="*" component={NotFound} />
							</Switch>
						</div>
						</ReactCSSTransitionReplace>
				</App>
			)} />
		</Switch>
	</Router>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./client/index.js